import ServiceExec from '@/common/utils/ServiceExec'

class MainSvc extends ServiceExec {
  getMainData(params = {}) {
    return this.queryPost(`/api/app/main/getMainData`, params)
      .then(res => res.data)
  }

  getCustomerCase(params = {}) {
    return this.queryPost(`/api/app/main/getCustomerCaseList`, params)
      .then(res => res.data)
  }

  getServiceStatus(params = {}) {
    return this.queryPost(`/api/app/main/getServiceStatus`, params)
      .then(res => res.data)
  }
}

export default new MainSvc()
